import React from 'react';
import IconImg from './IconImg';
import { CASINO_TILES, EVT } from '../../data/homeData';

export default function CasinoProviderGrid() {
  return (
    <div className="card">
      <div className="card-body card-content p-0">
        <div className="bet-table-header green-title">
          <span className="list-sport-title">
            <IconImg className="img-fluid game-icon-img" src={`${EVT}/menu-99998.png`} /> Casino Provider
          </span>
        </div>
        <div className="casinoprovider-thumb-section">
          {CASINO_TILES.map((t) => (
            <div className="cts-img popularDiv" key={t.label} title={t.label}>
              {t.img
                ? <img className="img-fluid" src={t.img} alt={t.label} loading="lazy" />
                : <div className="cts-fallback">{t.label}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
